import { readEmbedUrl } from "../utils";
import { restJson } from "./httpClient";
import type { RefreshUrlResponse } from "../types";

const REFRESH_URL_PATH = "/ai/insights/refresh-url";

export type RefreshedUrl = {
  id: string;
  content: string;
  role: string;
  createdAt: string;
};

export async function refreshUrl(messageId: string): Promise<RefreshedUrl> {
  const response = await restJson<RefreshUrlResponse>(
    `${REFRESH_URL_PATH}?message_id=${encodeURIComponent(messageId)}`,
    { method: "POST" },
  );
  const { message } = response;
  const embedUrl = readEmbedUrl(message.metadata) ?? message.content;
  return {
    id: message.id,
    content: embedUrl,
    role: message.role,
    createdAt: message.created_at,
  };
}
